import {Injectable} from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {AutenticacionService} from "./autenticacion.service";
import {NotificacionesPush} from '../_models/notificaciones-push';

@Injectable({
  providedIn: 'root'
})
export class TasasVariablesCondicionesNotificacionesService {

  private rutServicioAuth = AppSettings.rutServicios + '/auth/notificacionesInformativas';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  crear(registro: any){
    registro.idUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    registro.idPadre = registro.ids.join(',');
    return this.httClient.post( this.rutServicioAuth, registro).pipe( map( res => res as any ) );
  }
}
